<template>
  <div id="layout">
    <template v-if="isInit">
      <router-view />
    </template>
    <!-- 登录弹框 -->
    <Login />
  </div>
</template>
<script>
import Login from "@/views/login.vue";
import storage from "@/utils/storage";
import { mapActions, mapGetters } from "vuex";
import { apiMoyuSdkLogin } from "@/api/user";
export default {
  data() {
    return {
      isInit: false,
    };
  },
  components: {
    Login,
  },
  computed: {
    ...mapGetters(["vuexInitData", "indexData"]),
  },
  async created() {
    this.showLoading();
    const { token, game_id, is_new, from, gid } = this.$route.query;

    if (from) {
      sessionStorage.setItem("from", from);
    }
    if (token) {
      storage.setItem("token", token);
      if (!is_new) {
        sessionStorage.setItem("isAutoLogin", true);
      }
    }
    if (game_id || gid) {
      sessionStorage.setItem("game_id", Number(game_id || gid));
    }
    if (is_new) {
      sessionStorage.setItem("is_new", is_new);
    }

    await this.getKfInit();
    await this.getIndexData();
    // 获取游戏信息后，修改title
    if (
      this.indexData &&
      this.indexData.chat_game &&
      this.indexData.chat_game.name
    ) {
      document.title = this.indexData.chat_game.name;
    }
    await this.getInitInfos();

    const localGameId = sessionStorage.getItem("game_id");
    const localToken = storage.getItem("token");

    // 摸鱼社登录
    if (
      !localToken &&
      localGameId &&
      navigator &&
      navigator.userAgent &&
      navigator.userAgent.includes("Hero")
    ) {
      moyuJSSDK.init({
        dev: process.env.NODE_ENV == "preview", // dev为真，测试环境
        gameId: localGameId, // 游戏id，创魔 126  王牌157  灵魂228  星际 2174，不传则默认2174
        success: (res) => {
          apiMoyuSdkLogin({
            token: res.token,
            game_id: localGameId,
          })
            .then((res) => {
              if (res.code === 0) {
                storage.removeItem("token");
                storage.setItem("token", res.data.token);
                // 检查是否有角色
                this.checkUserRole();
              }
            })
            .finally(() => {
              this.isInit = true;
            });
        },
        fail: (err) => {
          this.isInit = true;
          console.log(err);
        },
      });
    } else {
      this.isInit = true;
    }

    this.hideLoading();
  },
  mounted() {
    this.showLoading();
    if (this.isWeiXin() && !sessionStorage.getItem("is_new")) {
      // 微信自动登录跳转
      if (this.vuexInitData.is_zy) {
        const origin = location.origin;
        const search = location.search;
        const path = this.$route.path || "/user-center";
        const gameId = storage.getGameId();
        const query = search
          ? `${search}&game_id=${gameId}`
          : `?game_id=${gameId}`;
        const jump_url = encodeURI(origin + path + query);
        window.location =
          process.env.VUE_APP_API +
          "/v1/public/login/autologin?game_id=" +
          gameId +
          "&jump_url=" +
          jump_url;
      }
    }
    this.hideLoading();
  },
  methods: {
    ...mapActions(["getKfInit", "getUserInfo", "getIndexData"]),
    // 判断是否有角色
    checkUserRole() {
      // 判断是否有角色
      this.getRoleList()
        .then((res) => {
          if (res.code === 0) {
            if (!res.data.length) {
              this.$router.replace({
                path: "/bind-roles",
              });
            }
          }
        })
        .finally(() => {
          this.$eventBus.$emit("loginSuccess");
        });
    },
    async getRoleList() {
      await this.$store.dispatch("getRoleList");
    },
    async getInitInfos() {
      const token = storage.getItem("token");
      if (token) {
        await this.getRoleList();
        await this.getUserInfo();
      }

      this.$store.dispatch("getGlobalNotice");
    },
    isWeiXin() {
      var ua = window.navigator.userAgent.toLowerCase();

      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>
<style lang="less" scoped>
#layout {
  width: 100%;
  height: 100%;
}
</style>
